<template>
    <div id="project">
        <Header v-show="isShow" />
        <div v-bind:class="{ container: isShow }">
            <router-view />
            <Footer v-show="isShow" />
        </div>
    </div>
</template>
<script>
import Header from "./components/header.vue";
import Footer from './components/Footer.vue';

export default {
    name: "App",
    components: {
        Header,
        Footer
    },

    data() {
        return {
            isShow: true,
        };
    },
    mounted() {},
    methods: {},
    watch: {
        $route(to) {
            let path = to.path;
            let limit2 = ["course", "user", "gift"];
            if (path) {
                let array = path.split("/");
                if (array.length >= 3) {
                    if (array[1] == "user" || array[1] == "gift") {
                        this.isShow = false;
                    }
                }
                if (array.length >= 2) {
                    if (limit2.includes(array[1])) {
                        this.isShow = false;
                    } else{
                        this.isShow = true;
                    }
                }
            }
        },
    },
};
</script>
<style>
@import "./styles/global/global.scss";
</style>
